<template>
  <a-config-provider :locale="locale">
    <div id="app" v-if="!$is_dock_env">
      <router-view v-if="init" />
      <nLogin
        v-else
        ref="nlogin"
        title="微站污染分析"
        grantType="password"
        :appId="$app_id"
        logoImage=""
        logoWidth=""
        logoHeight=""
        :serverName="PROXY_TARGET"
        @success="success"
        @error="error"
      ></nLogin>
    </div>
    <div id="app" v-else v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <router-view v-if="init" />
    </div>
  </a-config-provider>
</template>

<script>
import { getWindDataFromCity } from "@/api/api";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { GetRequest } from "@/utils/util";
export default {
  name: "App",
  data() {
    return {
      init: false,
      loading: false,
      locale: zhCN,
      PROXY_TARGET: ''
    };
  },
  created() {
    this.PROXY_TARGET = process.env.PROXY_TARGET || location.host
    if (this.$is_dock_env) {
      this.loading = true;
      this.initBaseInfo();
    }
  },
  mounted() {
    // this.initBaseInfo()
    this.stringColor();
    // getWindDataFromCity()
  },
  methods: {
    success(e) {
      console.log(e);
      if (e.loginInfo) {
        this.$store.commit("setToken", e.loginInfo.access_token);
      }
      this.$store.commit("setLoginInfo", e);
      this.initBaseInfo();
    },
    error() {},
    initBaseInfo() {
      this.$store
        .dispatch("getUserInfo")
        .then(() => {
          this.init = true;
          this.loading = false;
        })
        .catch(() => {
          this.init = true;
          this.loading = false;
        });
    },
    stringColor() {
      String.prototype.colorRgb = function() {
        var sColor = this.toLowerCase();
        //十六进制颜色值的正则表达式
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        // 如果是16进制颜色
        if (sColor && reg.test(sColor)) {
          if (sColor.length === 4) {
            var sColorNew = "#";
            for (var i = 1; i < 4; i += 1) {
              sColorNew += sColor
                .slice(i, i + 1)
                .concat(sColor.slice(i, i + 1));
            }
            sColor = sColorNew;
          }
          //处理六位的颜色值
          var sColorChange = [];
          for (var i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
          }
          return "RGB(" + sColorChange.join(",") + ")";
        }
        return sColor;
      };
    }
  }
};
</script>

<style>
/*html { font-size: calc(112.5% + 0.25vw) }
*/
body {
  margin: 0;
}
.el-col {
  margin: 5px 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.anchorBL {
  /* display: none; */
}
.tb_value {
  font-size: 1.5vh;
  text-align: center;
  display: inline-block;
  height: 3vh;
  line-height: 3vh;
  border: 1px solid;
  min-width: 100px;
  margin-left: 0vh;
}
.tb_label {
  margin-bottom: 20px;
  margin-left: 1vw;
  font-size: 1.5vh;
  display: inline-block;
  width: 3.5vw !important;
}
.cus_dialog {
  background: #0b1f46 !important;
  color: #fff !important;
}
.cus_dialog .tb_label,
.cus_dialog .tb_value {
  color: white;
}
.el-card__body {
  overflow: hidden;
}

.el-card__body {
  padding: 10px !important;
}

.BMap_bubble_content {
  overflow: auto !important;
  /* height: 62.75vh !important; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue